import { createFormContext } from "@mantine/form";
import { IFormTrans } from "./types";

export const [TransFormProvider, useTransFormContext, useTransForm] =
  createFormContext<IFormTrans>();
